"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _button = require("../../button");
var _constants = require("../../button/constants");
var _context = require("../../context");
var _utils = require("../../utils");
var _ = require("./");
var _constants2 = require("./constants");
var _core = require("@emotion/core");
var _excluded = ["children"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PageHeaderDropdownButtonBase = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    backgroundColor: 'transparent',
    borderRadius: selectors.radius(_constants2.PAGE_HEADER_ITEM_RADIUS),
    padding: '8px 24px',
    height: '100%',
    width: '100%',
    fontWeight: selectors.fontWeight('regular'),
    justifyContent: 'flex-start',
    color: selectors.color(_constants2.PAGE_HEADER_ITEM_TEXT_COLOR),
    ':hover': {
      borderColor: 'transparent',
      backgroundColor: selectors.color(_constants2.PAGE_HEADER_ITEM_HOVER_BACKGROUND_COLOR)
    },
    ':focus': {
      borderColor: 'transparent',
      outlineColor: 'transparent'
    },
    ':focus-visible': {
      borderColor: 'transparent',
      outline: "".concat((0, _utils.px)(_constants.BORDER_WIDTH), " solid ").concat(selectors.color(_constants2.PAGE_HEADER_ITEM_BORDER_COLOR)),
      outlineOffset: _constants.OUTLINE_OFFSET
    },
    ':active': {
      borderColor: 'transparent',
      backgroundColor: selectors.color(_constants2.PAGE_HEADER_ITEM_ACTIVE_BACKGROUND_COLOR)
    }
  };
});
var PageHeaderDropdownButtonWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _core.jsx)(PageHeaderDropdownButtonBase, (0, _extends2.default)({
    shouldUseResponsiveContent: false,
    variant: _button.ButtonVariant.Tertiary
  }, forwardedProps, {
    ref: ref
  }), children);
});
var PageHeaderDropdownButtonWithDocs = (0, _stencilReactDesc.describe)(PageHeaderDropdownButtonWithoutDocs).description('Button dropdown item for PageHeader.');
PageHeaderDropdownButtonWithDocs.propTypes = _objectSpread(_objectSpread({}, (0, _utils.pick)(_button.Button.describedPropTypes, ['icon', 'iconPosition'])), (0, _utils.pick)(_.PageHeaderButton.describedPropTypes, ['children', 'icon']));
var PageHeaderDropdownButton = (0, _utils.withTestAttributes)({
  component: 'StencilReactPageHeaderDropdownButton'
})(PageHeaderDropdownButtonWithDocs);
exports.PageHeaderDropdownButton = PageHeaderDropdownButton;
PageHeaderDropdownButton.displayName = 'PageHeaderDropdownButton';